module.exports = __webpack_public_path__ + "img/audio_thumbnail_astrid.3eec8f23.png";